export default "__VITE_ASSET__CEIYnK6t__"